import { MerchantValidationError } from "../error";
import * as Fields from "../fields";
import { FieldSet } from "../fieldset";
import { Merchant } from "../merchant";

export type CashPayFieldSetValueMap = {
  cashPayLogoUrl?: string;
};

export type CashPayFieldSetValueMapper<T> = {
  [K in keyof CashPayFieldSetValueMap]: T;
};

export class CashPayFieldSet extends FieldSet<CashPayFieldSetValueMap> {
  static fromJson(
    CashPay: CashPayFieldSet,
    { cashPayLogoUrl }: Partial<CashPayFieldSetValueMap>
  ): CashPayFieldSet {
    CashPay.cashPayLogoUrl.value = cashPayLogoUrl;

    return CashPay;
  }

  public cashPayLogoUrl: Fields.CashPayLogoUrlField;

  constructor(model: Merchant) {
    super();

    this.fieldSetName = "CashPayFieldSet";

    this.cashPayLogoUrl = new Fields.CashPayLogoUrlField(model);

    this.fields = [this.cashPayLogoUrl];
  }

  validate({ stringify = true }: { stringify: boolean }): void {
    const Errors = new MerchantValidationError();

    let errorCount = 0;
    for (const field of this.fields) {
      try {
        field.validate();
      } catch (ex) {
        errorCount++;
        if (Errors.fieldErrorMap.cashPay) {
          Errors.fieldErrorMap.cashPay[
            field.propertyName as keyof CashPayFieldSetValueMap
          ] = { error: stringify ? ex.message : ex };
        }
      }
    }

    if (errorCount) {
      throw Errors.fieldErrorMap;
    }
  }
}
